import { Controller } from "stimulus"

// Bugfix 21 (#1391): vragen in een vragenlijst in een andere volgorde slepen.
// Na het neerzetten gaat de nieuwe volgorde naar de server; de pijltjes naast
// elke vraag blijven werken voor wie niet sleept (of zonder JavaScript).
//
// #1928 ronde 12: ook voor lidmaatschapgroepen en inkomstencategorieën.
//   param-value  de naam van de ids in het verzoek (standaard vraag_ids[])
//   greep-target staat er een greep in een regel, dan sleep je alleen aan die
//                greep, zodat de invoervelden in de regel gewoon werken
//   pijl-target  knoppen met data-richting="omhoog" of "omlaag"; na het slepen
//                staan de bovenste en onderste weer uit
export default class extends Controller {
  static targets = ["item", "nummer", "greep", "pijl"]
  static values = { url: String, param: { type: String, default: "vraag_ids[]" } }

  greepTargetConnected(greep) {
    const regel = greep.closest("[data-sorteerbaar-target~='item']")
    if (!regel) return

    regel.draggable = false
    greep.addEventListener("pointerdown", () => { regel.draggable = true })
    greep.addEventListener("pointerup", () => { if (this.gesleept !== regel) regel.draggable = false })
  }

  start(event) {
    if (!event.currentTarget.draggable) return
    this.gesleept = event.currentTarget
    this.gesleept.classList.add("is-sleept")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.gesleept.dataset.id)
  }

  over(event) {
    if (!this.gesleept) return
    event.preventDefault()
    const doel = event.currentTarget
    if (doel === this.gesleept) return

    this.itemTargets.forEach((item) => item.classList.toggle("is-doel", item === doel))
    const rect = doel.getBoundingClientRect()
    const erna = event.clientY > rect.top + rect.height / 2
    doel.parentNode.insertBefore(this.gesleept, erna ? doel.nextSibling : doel)
  }

  weg(event) {
    event.currentTarget.classList.remove("is-doel")
  }

  neerzetten(event) {
    event.preventDefault()
  }

  einde() {
    if (!this.gesleept) return
    this.gesleept.classList.remove("is-sleept")
    if (this.greepTargets.length) this.gesleept.draggable = false
    this.itemTargets.forEach((item) => item.classList.remove("is-doel"))
    this.gesleept = null
    this.hernummer()
    this.pijlenBijwerken()
    this.bewaar()
  }

  hernummer() {
    this.nummerTargets.forEach((nummer, i) => { nummer.textContent = i + 1 })
  }

  pijlenBijwerken() {
    const laatste = this.itemTargets.length - 1
    this.itemTargets.forEach((item, i) => {
      this.pijlTargets.filter((pijl) => item.contains(pijl)).forEach((pijl) => {
        pijl.disabled = pijl.dataset.richting === "omhoog" ? i === 0 : i === laatste
      })
    })
  }

  bewaar() {
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const body = new URLSearchParams()
    this.itemTargets.forEach((item) => body.append(this.paramValue, item.dataset.id))
    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token, "Accept": "application/json", "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
      credentials: "same-origin"
    }).then((antwoord) => {
      if (!antwoord.ok) window.location.reload()
    }).catch(() => window.location.reload())
  }
}
